const topics = [
  { name: '娱乐圈塌房', heat: '9.8万', tag: '爆', color: 'primary' },
  { name: '网红翻车现场', heat: '8.5万', tag: '热', color: 'primary' },
  { name: '明星恋情曝光', heat: '7.2万', tag: '新', color: 'accent' },
  { name: '短视频博主黑历史', heat: '6.8万', tag: '热', color: 'primary' },
  { name: '综艺节目内幕', heat: '5.9万', tag: '', color: 'secondary' },
  { name: '品牌代言翻车', heat: '5.3万', tag: '', color: 'secondary' },
  { name: '选秀节目潜规则', heat: '4.7万', tag: '新', color: 'accent' },
  { name: '大V博主被扒皮', heat: '4.2万', tag: '', color: 'secondary' },
  { name: '直播带货假货', heat: '3.9万', tag: '', color: 'secondary' },
  { name: '音乐节后台故事', heat: '3.5万', tag: '新', color: 'accent' },
  { name: '影视剧改剧本风波', heat: '3.1万', tag: '', color: 'secondary' },
] as const;

export default function SectionTopics() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          全网吃瓜群众正在热议的黑料话题
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          {topics.map((t) => {
            const tagColors: Record<string, string> = {
              primary: 'bg-primary-500 text-background-50',
              accent: 'bg-accent-500 text-background-50',
              secondary: 'bg-secondary-300 text-foreground-700',
            };
            return (
              <a
                key={t.name}
                href="#topics"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 border border-secondary-200/70 rounded-full hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer group"
              >
                {t.tag && (
                  <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full whitespace-nowrap leading-none ${tagColors[t.color]}`}>
                    {t.tag}
                  </span>
                )}
                <span className="text-sm text-foreground-700 group-hover:text-primary-700 whitespace-nowrap">
                  {t.name}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  {t.heat}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}